import React from 'react';
import { Box, Typography, Button } from '@mui/material';
import PlaceIcon from '@mui/icons-material/Place';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import IosShareIcon from '@mui/icons-material/IosShare';
import LocalFireDepartmentIcon from '@mui/icons-material/LocalFireDepartment';
import CoverStripes from './coverStripes';
import useCardStyles from './useCardStyles';
import * as styles from './styles';

function FeaturedCard({ publisher, onSync, onShare }) {
    const { coverGradient, logoGradient } = useCardStyles(publisher);

    function renderPills() {
        return (
            <Box sx={styles.coverTopLeft}>
                {publisher.rankLabel && (
                    <Box sx={styles.pillHot}>
                        <LocalFireDepartmentIcon sx={{ fontSize: 12 }} />
                        {publisher.rankLabel}
                    </Box>
                )}
                <Box sx={styles.pill}>
                    {publisher.industries?.[0]}
                </Box>
            </Box>
        );
    }

    function renderScorePill() {
        if (!publisher.score) return null;
        return (
            <Box sx={styles.coverTopRight}>
                <Box sx={styles.pillRank}>{publisher.score}</Box>
            </Box>
        );
    }

    function renderPublisherInfo() {
        return (
            <Box sx={styles.coverBottom}>
                {publisher.logo ? (
                    <Box
                        component="img"
                        src={publisher.logo}
                        alt={publisher.name}
                        sx={styles.publisherLogo}
                    />
                ) : (
                    <Box sx={{ ...styles.publisherLogo, background: logoGradient, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                        <Typography sx={{ fontSize: '1.25rem', fontWeight: 700, color: '#fff' }}>
                            {publisher.name?.[0]}
                        </Typography>
                    </Box>
                )}
                <Box sx={{ minWidth: 0 }}>
                    <Typography sx={styles.publisherName}>{publisher.name}</Typography>
                    <Typography sx={styles.publisherTimezone}>
                        <PlaceIcon sx={{ fontSize: 12 }} />
                        {publisher.timezone}
                    </Typography>
                </Box>
            </Box>
        );
    }

    function renderNextEvent() {
        return (
            <Box sx={{ minHeight: '20px' }}>
                {/* TODO: re-enable when next event data is available
                <Typography sx={styles.nextEventLabel}>Next event</Typography>
                <Typography sx={styles.nextEventName}>{publisher.nextEvent?.title}</Typography>
                <Typography sx={styles.countdown}>{publisher.nextEvent?.countdown}</Typography>
                */}
            </Box>
        );
    }

    function renderActions() {
        return (
            <Box sx={styles.actions}>
                <Button
                    variant="contained"
                    startIcon={<CalendarMonthIcon />}
                    onClick={() => onSync(publisher)}
                    sx={styles.syncButton}
                >
                    {publisher.actionButton}
                </Button>
                <Box sx={styles.shareWrapper}>
                    <Button
                        onClick={() => onShare(publisher)}
                        aria-label={`Share ${publisher.name}`}
                        sx={styles.shareButton}
                    >
                        <IosShareIcon sx={{ fontSize: 18 }} />
                    </Button>
                </Box>
            </Box>
        );
    }

    const coverStyle = publisher.coverPhoto
        ? { ...styles.cover, backgroundImage: `url(${publisher.coverPhoto})`, backgroundSize: 'cover', backgroundPosition: 'center' }
        : { ...styles.cover, background: coverGradient };

    return (
        <Box component="article" sx={styles.card}>
            <Box sx={coverStyle}>
                {!publisher.coverPhoto && <CoverStripes />}
                {renderPills()}
                {renderScorePill()}
                {renderPublisherInfo()}
            </Box>
            <Box sx={styles.body}>
                {renderNextEvent()}
                {renderActions()}
            </Box>
        </Box>
    );
}

export default FeaturedCard;
